(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-auto"] && !Shopify.designMode) return;
  try {
    
  /* Rien d’obligatoire en JS pour l’effet.
   Si tu veux, tu peux synchroniser la hauteur des items ou d’autres raffinements ici.
*/

  } catch(e) { console.error(e); }
})();
})();
